import { differenceInYears, format, parse } from 'date-fns'
import {
  DateString,
  DatetimeSecondString,
  ShortDateString,
  TimeString,
} from 'config/format'
import { jstNewDate } from 'ui/utils/jstDatetime'
import getDateLocale from 'ui/utils/getDateLocale'
import i18n from '../../i18n'

export const formatYearDateJpDayOfWeek = (date: Date): string => {
  return format(date, i18n.t('datetime.yyyy年M月d日 EEEE'), {
    locale: getDateLocale(),
  })
}

export const formatYearDateJpDayOfWeekTime = (date: Date): string => {
  return format(date, i18n.t('datetime.yyyy年M月d日 EEEE HH:mm'), {
    locale: getDateLocale(),
  })
}

export const formatDateString = (date: Date): string => {
  return format(date, DateString)
}

export const formatShortDateString = (date: Date): string => {
  return format(date, ShortDateString)
}

export const formatDateTimeSecondString = (date: Date): string => {
  return format(date, DatetimeSecondString)
}

export const parseDateString: (string: string) => Date = (string) => {
  return parse(string, DateString, new Date())
}

export const parseDatetimeSecondString: (string: string) => Date = (string) => {
  return parse(string, DatetimeSecondString, new Date())
}

export const formatTimeString = (date: Date): string => {
  return format(date, TimeString)
}

export const formatDateTimeJp = (date: Date): string => {
  return format(date, i18n.t('datetime.M月d日 (E) H:mm'), {
    locale: getDateLocale(),
  })
}

const formatYearDateJp = (date: Date): string => {
  return format(date, i18n.t('datetime.yyyy年M月d日'))
}

export const reformatBirthday = (dateString: string) => {
  const date = parseDateString(dateString)
  const age = differenceInYears(jstNewDate, date)
  return `${formatYearDateJp(date)} ${age}${i18n.t('歳')}`
}
